import accentsAvoidYellowDoLight from "../../../../src/pages/foundations/color/accents/_assets/accents-avoid-yellow-do-light.png";
import accentsAvoidYellowDontLight from "../../../../src/pages/foundations/color/accents/_assets/accents-avoid-yellow-dont-light.png";
import accentsBackgroundAccentTokensLight from "../../../../src/pages/foundations/color/accents/_assets/accents-background-accent-tokens-light.png";
import accentsBorderTokenLight from "../../../../src/pages/foundations/color/accents/_assets/accents-border-token-light.png";
import accentsColorAccessibility2Light from "../../../../src/pages/foundations/color/accents/_assets/accents-color-accessibility-2-light.png";
import accentsColorAccessibilityLight from "../../../../src/pages/foundations/color/accents/_assets/accents-color-accessibility-light.png";
import accentsColorsLight from "../../../../src/pages/foundations/color/accents/_assets/accents-colors-light.png";
import accentsIconsLight from "../../../../src/pages/foundations/color/accents/_assets/accents-icons-light.png";
import accentsRoleDont from "../../../../src/pages/foundations/color/accents/_assets/accents-role-dont.png";
import accentsRoleDo from "../../../../src/pages/foundations/color/accents/_assets/accents-role-do.png";
import accentsMixingColorsDontLight from "../../../../src/pages/foundations/color/accents/_assets/accents-mixing-colors-dont-light.png";
import accentsMixingColorsDoLight from "../../../../src/pages/foundations/color/accents/_assets/accents-mixing-colors-do-light.png";
import accentsTextAccentTokensLight from "../../../../src/pages/foundations/color/accents/_assets/accents-text-accent-tokens-light.png";
import accentsWhiteboardLight from "../../../../src/pages/foundations/color/accents/_assets/accents-whiteboard-light.png";
import * as React from 'react';
export default {
  accentsAvoidYellowDoLight,
  accentsAvoidYellowDontLight,
  accentsBackgroundAccentTokensLight,
  accentsBorderTokenLight,
  accentsColorAccessibility2Light,
  accentsColorAccessibilityLight,
  accentsColorsLight,
  accentsIconsLight,
  accentsRoleDont,
  accentsRoleDo,
  accentsMixingColorsDontLight,
  accentsMixingColorsDoLight,
  accentsTextAccentTokensLight,
  accentsWhiteboardLight,
  React
};